import Endpoint from "@/utils/endPoint.js";

const mediaEndpoint = new Endpoint("/media/");
const mediaUploadEndpoint = new Endpoint("/media/{mediaId}/uploaded");

class MediaService {
    async createMediaService(params) {
        const result = await mediaEndpoint.post(params);
        return result;
    }
    
    async uploadMediaService(params) {
        const result = await mediaUploadEndpoint.put(null, params);
        return result;
    }
}

export default new MediaService();
